// 实物管理
import { get, postJson, put, deleteApi,postJsonBlob } from "../axios2";
const RESOURCE_BASE_PATH = "/pointActivityGoodsManagement"

// 创建实物接口
export const createGoods = (p) => postJson(`${RESOURCE_BASE_PATH}/`, p);

// 实物分页查询接口
export const getGoodsPage = (p) => get(`${RESOURCE_BASE_PATH}/page`, p);

// 实物汇总剩余数量接口
export const getAllRemanentAmount = (p) => get(`${RESOURCE_BASE_PATH}/remanentAmount`, p);

// 修改实物接口
export const updateGoods = (p) => put(`${RESOURCE_BASE_PATH}/`, p);

// 增减实物库存接口
export const updateInventory = (p) => put(`${RESOURCE_BASE_PATH}/inventory`, p);

//删除实物接口
export const deleteGoods = (p) => deleteApi(`${RESOURCE_BASE_PATH}/${p}`);

//实物发放记录分页接口
export const getSendRecord = (p) => get(`${RESOURCE_BASE_PATH}/sendRecord/page`,p);

//实物发放导出接口
export const exportSendRecord = (p) => postJsonBlob(`/jd-hd-web${RESOURCE_BASE_PATH}/sendRecord/export`,p);